import { onError } from "@apollo/client/link/error";
import { useOnErrorScreen } from "@magalu/ravejs-platform-hooks/services";

export const errorLink = onError(({ networkError, operation }) => {
  if (operation.operationName === "root" && networkError) {
    const errorCode = networkError.message
      .toLocaleLowerCase()
      .includes("timeout")
      ? 504
      : 500;
    useOnErrorScreen({ errorCode }, console);
    networkError.message = `[NetworkError:${errorCode}] ${networkError.message}`;
    throw networkError;
  }
});
